import { UseCase } from '../UseCase';
import { Commission } from '../../models/Commission';
import { BalanceRepository } from '../../repositories/BalanceRepository';

export class GetCommissionsUseCase implements UseCase<GetCommissionsRequestDto, Commission[]>{

    constructor(
        private balanceRepo: BalanceRepository
    ) { }

    execute(_: GetCommissionsRequestDto): Promise<Commission[]> {
        return this.balanceRepo.getCommissions();
    }

}

export class GetCommissionsRequestDto {
}